import React, { useEffect, useState, useContext } from 'react';
import Select from "react-select";
import Swal from 'sweetalert2';
import ApiAlunos from '../services/alunoService';
import ApiMunicipios from '../services/municipioService';
import { Context } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import ImageUploader from '../section-pages/ImageUploader';
import InputCPF from "../components/InputCpf";

export default function AlunoFormulario() {
    
    const navigate = useNavigate();
    const { handleLogout } = useContext(Context);  
    const [id, setId] = useState('');
    const [userId, setUserId] = useState('');
    const [nome, setNome] = useState('');
    const [cpf, setCpf] = useState('');
    const [municipioId, setMunicipioId] = useState('');
    const [cpfValido, setCpfValido] = useState("");
    const [email, setEmail] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [idade, setIdade] = useState('');
    const [faixa, setFaixa] = useState('');
    const [listaMunicipios, setListaMunicipios] = useState([]);
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [image, setImage] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const dados = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token');
    
    const getAluno = async (userId) => {
        try {
            const response = await ApiAlunos.getAlunoPorUserId(userId, token);
            if (response.statusRetorno === 401){
                handleLogout();
                navigate('/');
            }
            setId(response.data.aluno[0].id)
            setNome(response.data.aluno[0].nome)
            setEmail(response.data.aluno[0].email)
            setCpf(response.data.aluno[0].cpf)
            setDataNascimento(response.data.aluno[0].dataNascimento)
            setImagePreview(response.data.aluno[0].foto)
            setIdade(response.data.aluno[0].idadeAtual)
            setFaixa(response.data.graduacao[0].faixa)
            setMunicipioId(response.data.aluno[0].municipioId)
        } catch (error) {
            console.error('Erro ao buscar daddos do aluno:', error);
        } finally {
            setIsLoading(false);
        }
    };
    
    const obterListaMunicipios = async () => {
        const response = await ApiMunicipios.listar();
        if (response.statusRetorno !== 200) {
            Swal.fire({
                title: 'Erro ao carregar Municipios!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        } else {
            setListaMunicipios(response.data);
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            id: id,
            user_id: userId,
            name: nome,
            email: email,
            data_nascimento: dataNascimento,
            senha: password,
            foto: image,
            cpf: cpf,
            municipio_id: municipioId,
        };

        try {
            const response = await ApiAlunos.save(data, token);
            if (response.statusRetorno === 200) {
                Swal.fire({
                    text: 'Seus dados foram alterados com sucesso',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })
            } else {
                Swal.fire({
                    title: 'Houve um erro ao tentar editar seus dados!',
                    text: response.message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            }
        } catch (error) {
            Swal.fire({
                title: 'Houve um erro ao tentar editar seus dados!',
                text: error,
                icon: 'error',
                confirmButtonText: 'Ok'
                })
        }
    };

    useEffect(() => {
        setUserId(dados.id)
        getAluno(dados.id)
        obterListaMunicipios()
    }, []);

    return (
        <form name="contactForm" id='contact_form' className="form-border" onSubmit={handleSubmit}>
            <h4>Bem vindo NOME DO ALUNO.</h4>
            
            <div className="row">
                <div className="col-md-6">
                    <div className="field-set">
                        <label>Nome:</label>
                        <input 
                            type='text' 
                            value={nome} 
                            required 
                            className="form-control"
                            placeholder="Seu Nome"
                            onChange={(event) => setNome(event.target.value)}
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="field-set">
                        <label>Email:</label>
                        <input 
                            type='email' 
                            value={email} 
                            required 
                            className="form-control"
                            placeholder="Seu Email"
                            onChange={(event) => setEmail(event.target.value)}
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="col-md-6">
                        <div className="field-set">
                            <ImageUploader
                                imagePreview={imagePreview}
                                onImageChange={(file, preview) => {
                                    setImage(file);
                                    setImagePreview(preview);
                                }}
                                onRemoveImage={() => {
                                    setImage('');
                                    setImagePreview('');
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-8">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="field-set">
                                <label>CPF</label>
                                <InputCPF
                                    value={cpf}
                                    onChange={setCpf}
                                    onValidChange={(valido) => setCpfValido(valido)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="field-set">
                                <label>Data de Nascimento</label>
                                <input 
                                    type='date' 
                                    value={dataNascimento} 
                                    required 
                                    className="form-control"
                                    placeholder="Sua Data de Nascimento"
                                    onChange={(event) => setDataNascimento(event.target.value)}
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="field-set">
                                <label>Senha:</label>
                                <input 
                                    type='password' 
                                    className="form-control"
                                    placeholder="Digite sua nova senha"
                                    onChange={(event) => setPassword(event.target.value)}
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <label>Município *</label>
                            <Select
                                options={
                                    listaMunicipios.map((m) => ({
                                    value: m.id,
                                    label: m.municipio,
                                }))}
                                value={
                                    listaMunicipios
                                    .map((m) => ({ value: m.id, label: m.municipio }))
                                    .find((opt) => opt.value === municipioId) || null
                                }
                                onChange={(selected) => setMunicipioId(selected?.value || '')}
                                placeholder="Digite para buscar..."
                                isSearchable
                                noOptionsMessage={() => "Nenhum município encontrado"}
                            />
                        </div>
                        <div className="col-md-4">
                            <div className="field-set">
                                <label>Idade</label>
                                <br/><strong>{idade} anos</strong>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="field-set">
                                <label>Categoria / Faixa</label>
                                <br/><strong>{faixa}</strong>
                            </div>
                        </div>
                        <div className="col-lg-12 my-3">
                            <div id='submit'>
                                <input 
                                    type='submit' 
                                    value='Salvar' 
                                    className="btn-main color-2"
                                />
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </form>
    );
}
